import classnames from 'classnames';
import * as React from 'react';
import { List } from 'palette/List';
import './FilterDropdownList.scss';

type FilterDropdownListProps = React.PropsWithChildren<{
    className?: string;
}>;

export default function FilterDropdownList({
    className,
    children,
} : FilterDropdownListProps) {
    return (
        <List className={classnames('palette-filter-dropdown-list', className)}>
            {children}
        </List>
    );
}
